import React from 'react';
import './VoiceAiPage.css';

const VoiceAiPage = ({ onContactClick }) => {
  const features = [
    {
      icon: "📞",
      title: "24/7 AI Call Answering",
      desc: "A natural, human sounding voice that picks up every call, greets customers warmly, answers common questions, and supports your business with clear, accurate information."
    },
    {
      icon: "📅",
      title: "Appointment Booking",
      desc: "Connects with your calendar to book, reschedule, and confirm appointments instantly."
    },
    {
      icon: "⚡",
      title: "CRM & Tool Integrations",
      desc: "Works with your PMS, CRM, and marketing tools so your data stays in sync across your systems."
    },
    {
      icon: "⇄",
      title: "Custom Call Flows",
      desc: "Routes calls based on types, urgency, or location, so every customer reaches the right place quickly."
    },
    {
      icon: "📊",
      title: "Call Analytics Dashboard",
      desc: "View every call, booking, and conversion in one dashboard. See what is working and where customers drop off."
    },
    {
      icon: "👥",
      title: "Human Escalation",
      desc: "When a call needs a personal touch, it transfers smoothly to your front desk team."
    }
  ];

  return (
    <div className="voice-ai-page">
      {/* Hero Section */}
      <section className="voice-hero">
        <div className="voice-hero-content">
          <h1 className="voice-hero-title">Voice AI</h1>
          <p className="voice-hero-subtitle">INBOUND VOICE AGENTS, OUTBOUND VOICE AGENTS, LEAD REACTIVATION AGENTS.</p>
          <p className="voice-hero-desc">
            24/7 AI call answering that converts leads into booked clients. Premium solutions that turn every opportunity into growth.
          </p>
          
          <div className="voice-hero-stats">
            <div className="voice-stat-item">
              <h3>40%</h3>
              <p>More Appointments Captured</p>
            </div>
            <div className="voice-stat-item">
              <h3>87%</h3>
              <p>Conversion Rate</p>
            </div>
            <div className="voice-stat-item">
              <h3>18%</h3>
              <p>Fewer No-Shows</p>
            </div>
          </div>
          
          <div className="voice-hero-cta">
            <button className="voice-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="voice-btn-secondary">
              <span className="play-icon">▶</span> Listen to demo
            </button>
          </div>
        </div>
        
        <div className="voice-hero-visual">
          <div className="voice-glowing-ring"></div>
        </div>
      </section>

      {/* Features Section */}
      <section className="voice-features-section">
        <h2 className="voice-section-title">More than just a call bot.</h2>
        
        <div className="voice-features-grid">
          {features.map((feat, index) => (
            <div key={index} className="voice-feature-card">
              <div className="feature-icon">{feat.icon}</div>
              <h3 className="feature-title">{feat.title}</h3>
              <p className="feature-desc">{feat.desc}</p>
            </div>
          ))}
        </div>
        
        <p className="voice-features-footer">
          Need something custom? We can deploy and integrate with your existing systems.
        </p>
      </section>

      {/* Comparison Section */}
      <section className="voice-comparison-section">
        <h2 className="voice-comparison-title">AI Receptionist vs Hiring Another Front Desk</h2>
        <p className="voice-comparison-subtitle">See the Difference in One Glance</p>
        
        <div className="voice-table-container">
          <table className="voice-comparison-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>cabptoid AI</th>
                <th>Human Staff</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Availability</td>
                <td className="pro-cell"><span className="check-icon">✓</span> 24/7 coverage</td>
                <td className="con-cell"><span className="cross-icon">✕</span> Limited to office hours, missed calls = missed patients</td>
              </tr>
              <tr>
                <td>Response rate</td>
                <td className="pro-cell"><span className="check-icon">✓</span> Answers in 2 seconds, no hold time or ring delay</td>
                <td className="con-cell"><span className="cross-icon">✕</span> Varies, busy, away, or juggling multiple calls</td>
              </tr>
              <tr>
                <td>Follow-ups & reminders</td>
                <td className="pro-cell"><span className="check-icon">✓</span> Automatic, sends confirmations and no-show reminders</td>
                <td className="con-cell"><span className="cross-icon">✕</span> Manual, time-consuming and easy to miss</td>
              </tr>
              <tr>
                <td>Training required</td>
                <td className="pro-cell"><span className="check-icon">✓</span> None, ready on day 1</td>
                <td className="con-cell"><span className="cross-icon">✕</span> Ongoing, hiring, onboarding, retraining</td>
              </tr>
              <tr>
                <td>Scalability</td>
                <td className="pro-cell"><span className="check-icon">✓</span> Instant, handles multiple calls at once</td>
                <td className="con-cell"><span className="cross-icon">✕</span> One call at a time</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* CTA Section */}
      <section className="voice-cta-section">
        <div className="voice-cta-content">
          <h2>Ready to get started?</h2>
          <p>Book a call. We'll walk through your setup and show you a live flow.</p>
          <button className="voice-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default VoiceAiPage;
